// Settings styles
export const settingsStyles = {
    tabButton: {
        textTransform: 'none',
        borderRadius: '0',
        maxWidth: '120px',
        width: '100%',
        padding: '0.875rem 1rem',
        color: '#191C1B',
    }
};
